module.exports = __webpack_public_path__ + "img/slider_3.754a4aa4.jpg";